import PropTypes from 'prop-types'
import React, { Component } from "react"
import { connect } from "react-redux"
import { withRouter, Link } from "react-router-dom"

import {
  changeLayout,
  changeTopbarTheme,
  changeLayoutWidth,
} from "../../store/actions"

// Other Layout related Component

import Header from "./Header"
import Footer from "./Footer"
import Rightbar from "../CommonForBoth/Rightbar";
import Utils from '../../pages/Utility'

class Layout extends Component {
  constructor(props) {
    super(props)
    this.state = {
      isMenuOpened: false,
    }
  }

  componentDidMount() {
    if (this.props.isPreloader === true) {
      document.getElementById("preloader").style.display = "block"
      document.getElementById("status").style.display = "block"

      setTimeout(function () {
        document.getElementById("preloader").style.display = "none"
        document.getElementById("status").style.display = "none"
      }, 2500)
    } else {
      document.getElementById("preloader").style.display = "none"
      document.getElementById("status").style.display = "none"
    }

    // Scrollto 0,0
    window.scrollTo(0, 0)

    const title = this.props.location.pathname
    let currentage = title.charAt(1).toUpperCase() + title.slice(2)

    document.title =
      currentage + " | " + Utils.projectName

    this.props.changeLayout("horizontal")
    if (this.props.topbarTheme) {
      this.props.changeTopbarTheme(this.props.topbarTheme)
    }
    if (this.props.layoutWidth) {
      this.props.changeLayoutWidth(this.props.layoutWidth)
    }
  }

  /**
   * Opens the menu - mobile
   */
  openMenu = () => {
    this.setState({ isMenuOpened: !this.state.isMenuOpened })
  }
  render() {
    return (
      <React.Fragment>
        <div id="preloader">
          <div id="status">
            <div className="spinner-chase">
              <div className="chase-dot"></div>
              <div className="chase-dot"></div>
              <div className="chase-dot"></div>
              <div className="chase-dot"></div>
              <div className="chase-dot"></div>
              <div className="chase-dot"></div>
            </div>
          </div>
        </div>
        <div className="container-fluid">
          <div id="layout-wrapper">
            <header id="page-topbar" style={{ backgroundColor: this.props.user?.company?.theme ? this.props.user?.company?.theme : Utils.themeColor }}>
              <Header
                theme={this.props.topbarTheme}
                isMenuOpened={this.state.isMenuOpened}
                openLeftMenuCallBack={this.openMenu}
                user={this.props?.user}
              >
              </Header>
              <div className='section-dot' >
                <div className='nav_box'>
                  <ul>
                    <li> <Link to='/dashboard'>DASHBOARD</Link></li>
                    <div class="dropdown">
                      <button class="dropbtn">PROJECT</button>
                      <div class="dropdown-content">
                        <Link to="/project">ADD PROJECT</Link>
                        <Link to="/tags">TAG MASTER</Link>
                        <Link to="/technologies">TECHNOLOGY MASTER</Link>
                        <Link to="/type"> PROJECT TYPE</Link>
                      </div>
                    </div>
                    <div class="dropdown">
                      <button class="dropbtn">CAREER</button>
                      <div class="dropdown-content">
                        <Link to="/jobs">ADD JOB</Link>
                        <Link to="/career">VIEW RESUME</Link>
                      </div>
                    </div>
                    <div class="dropdown">
                      <button class="dropbtn">BLOG</button>
                      <div class="dropdown-content">
                        <Link to="/blogs">ADD BLOG</Link>
                        <Link to="/image-store">IMAGE STORE</Link>
                      </div>
                    </div>
                    <li> <Link to='/contact_us'>CONTACT US</Link></li>
                    <div class="dropdown">
                      <button class="dropbtn">OTHER</button>
                      <div class="dropdown-content">
                        <Link to="/social-media">SOCIAL MEDIA</Link>
                      </div>
                    </div>
                    <div class="dropdown">
                      <button class="dropbtn">USA</button>
                      <div class="dropdown-content">
                        <Link to="/contact-us">CONTACT US</Link>
                        <Link to="/rajmith-us-sub">SUBSCRIPTION</Link>
                      </div>
                    </div>
                    <div class="dropdown">
                      <button class="dropbtn">Hourly Tech Jobs</button>
                      <div class="dropdown-content">
                        <Link to="/hourly-tech-jobs-contact">CONTACT US</Link>
                        <Link to="/hourly-tech-jobs-career">CAREER</Link>
                      </div>
                    </div>
                  </ul>
                </div>
              </div>
            </header>
            <div className="main-content pt-5">
              {this.props.children}
              <Footer />
            </div>
          </div>
        </div>
        {this.props.showRightSidebar ? <Rightbar user={this.props.user} /> : null}
      </React.Fragment>
    )
  }
}

Layout.propTypes = {
  changeLayout: PropTypes.func,
  changeLayoutWidth: PropTypes.func,
  changeTopbarTheme: PropTypes.func,
  children: PropTypes.object,
  isPreloader: PropTypes.any,
  layoutWidth: PropTypes.any,
  location: PropTypes.object,
  showRightSidebar: PropTypes.any,
  topbarTheme: PropTypes.any
}

const mapStatetoProps = state => {
  return {
    ...state.Layout,
    user: state.Profile?.user
  }
}
export default connect(mapStatetoProps, {
  changeTopbarTheme,
  changeLayout,
  changeLayoutWidth,
})(withRouter(Layout))
